// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "text-2LZr9";
export { _1 as "__esModule", _2 as "text" }
export default { "__esModule": _1, "text": _2 }
